import { useState } from "react";

export const useDateRangeSelection = () => {
  const [viewDate, setViewDate] = useState(() => new Date());
  const [rangeStart, setRangeStart] = useState<Date | null>(null);
  const [rangeEnd, setRangeEnd] = useState<Date | null>(null);

  const selectDay = (day: Date) => {
    if (!rangeStart || rangeEnd) {
      setRangeStart(day);
      setRangeEnd(null);
      return;
    }

    if (day.getTime() < rangeStart.getTime()) {
      setRangeEnd(rangeStart);
      setRangeStart(day);
    } else {
      setRangeEnd(day);
    }
  };

  const goToPrevMonth = () =>
    setViewDate((d) => new Date(d.getFullYear(), d.getMonth() - 1, 1));

  const goToNextMonth = () =>
    setViewDate((d) => new Date(d.getFullYear(), d.getMonth() + 1, 1));

  const reset = () => {
    setRangeStart(null);
    setRangeEnd(null);
  };

  return {
    viewDate,
    rangeStart,
    rangeEnd,
    selectDay,
    goToPrevMonth,
    goToNextMonth,
    reset,
  };
};
